/**
 * DashboardSystemInfoRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * DashboardSystemInfoRes
 */
export interface DashboardSystemInfoRes {
  /** 服务器时间（毫秒时间戳） */
  server_time?: number
  /** 系统版本 */
  version?: string
  /** 运行环境 */
  environment?: string
  /** 数据库大小 */
  database_size?: string
  /** 缓存大小 */
  cache_size?: string
  /** Go版本 */
  go_version?: string
  /** 操作系统 */
  os?: string
  /** 系统架构 */
  arch?: string
  /** CPU核心数 */
  cpu_count?: number
  /** 内存使用情况 */
  memory_usage?: string
  /** 运行时长（秒） */
  uptime?: number
}

/**
 * DashboardSystemInfoRes Schema
 */
export const DashboardSystemInfoResSchema: SchemaDefinition = {
  properties: {
    server_time: {
      description: '服务器时间（毫秒时间戳）',
      format: 'int64',
      type: 'integer',
      label: '服务器时间',
    },
    version: {
      description: '系统版本',
      format: 'string',
      type: 'string',
      label: '系统版本',
    },
    environment: {
      description: '运行环境',
      format: 'string',
      type: 'string',
      label: '运行环境',
    },
    database_size: {
      description: '数据库大小',
      format: 'string',
      type: 'string',
      label: '数据库大小',
    },
    cache_size: {
      description: '缓存大小',
      format: 'string',
      type: 'string',
      label: '缓存大小',
    },
    go_version: {
      description: 'Go版本',
      format: 'string',
      type: 'string',
      label: 'Go版本',
    },
    os: {
      description: '操作系统',
      format: 'string',
      type: 'string',
      label: '操作系统',
    },
    arch: {
      description: '系统架构',
      format: 'string',
      type: 'string',
      label: '系统架构',
    },
    cpu_count: {
      description: 'CPU核心数',
      format: 'int',
      type: 'integer',
      label: 'CPU核心数',
    },
    memory_usage: {
      description: '内存使用情况',
      format: 'string',
      type: 'string',
      label: '内存使用情况',
    },
    uptime: {
      description: '运行时长（秒）',
      format: 'int64',
      type: 'integer',
      label: '运行时长',
    },
  },
  type: 'object',
}
